import cityList from './assets/city.json';
import { compare, convertArrayToObject } from './utils';
var KEYS = ["name", "countryCode", "stateCode", "latitude", "longitude"];
var convertedCityList = [];
// Get a list of all cities.
function getAllCities() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : KEYS;
  if (convertedCityList.length) {
    return convertedCityList;
  }
  var cityJSON = cityList;
  convertedCityList = convertArrayToObject(keys !== null && keys !== void 0 ? keys : KEYS, cityJSON);
  return convertedCityList;
}
// Get a list of cities belonging to a specific state and country.
function getCitiesOfState(countryCode, stateCode) {
  if (!stateCode) return [];
  if (!countryCode) return [];
  var cityList = getAllCities();
  var cities = cityList.filter(function (value) {
    return value.countryCode === countryCode && value.stateCode === stateCode;
  });
  return cities.sort(compare);
}
// Get a list of cities belonging to a specific country.
function getCitiesOfCountry(countryCode) {
  if (!countryCode) return [];
  var cityList = getAllCities();
  var cities = cityList.filter(function (value) {
    return value.countryCode === countryCode;
  });
  return cities.sort(compare);
}
function sortByStateAndName(cities) {
  return cities.sort(function (a, b) {
    var result = compare(a, b, function (entity) {
      return "".concat(entity.countryCode, "-").concat(entity.stateCode);
    });
    if (result !== 0) return result;
    return compare(a, b);
  });
}
export default {
  getAllCities: getAllCities,
  getCitiesOfState: getCitiesOfState,
  getCitiesOfCountry: getCitiesOfCountry,
  sortByStateAndName: sortByStateAndName
};